import React from 'react';
import { List } from 'antd-mobile';
import './patientDetails.css';

const TrainTable = ({ columns, dataSource }) => {
  return (
    <List>
      <List.Item>
        <div className="table-row header">
          {columns.map((col) => (
            <div className="table-cell c_111827" key={col.dataIndex}>
              {col.title}
            </div>
          ))}
        </div>
      </List.Item>
      {dataSource.map((data, index) => (
        <List.Item key={index}>
          <div className="table-row">
            {columns.map((col, colIndex) => (
              <div className="table-cell c_718096" key={col.dataIndex}>
                {data[col.dataIndex]}
                {colIndex === 1 && ' 分钟'}
              </div>
            ))}
          </div>
        </List.Item>
      ))}
    </List>
  );
};

export default TrainTable;
